import { ChartDataItem } from './types';

export const sampleData = <T extends ChartDataItem>(
	data: T[],
	maxDataPoints: number
): T[] => {
	if (data.length <= maxDataPoints) {
		return data;
	}

	const k = Math.ceil(data.length / maxDataPoints);
	return data.filter(
		(_, index) => data.length <= maxDataPoints || index % k === 0
	);
};
